const value = (name: string) => String(import.meta.env[name] ?? "").trim();

export const env = {
  supabaseUrl: value("VITE_SUPABASE_URL"),
  supabaseAnonKey: value("VITE_SUPABASE_ANON_KEY"),
  appEnv: value("VITE_APP_ENV") || "local",
  lineMode: (value("VITE_LINE_MODE") || "development") as "development" | "line",
  lineLiffId: value("VITE_LINE_LIFF_ID"),
  devLineUserId: value("VITE_DEV_LINE_USER_ID") || "U-DEV-ATTENDANCE-001",
};

export const isConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
